<template>

      <div class="card h-100 shadow-sm  p-3 rounded-3">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span>{{title}}</span>
        </div>
        <div class="ratio ratio-16x9"><canvas ref="chartBlock" /></div>
      </div>

</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import Chart from 'chart.js/auto'

const props = defineProps({
  graphicObj: {
    type: Object,
    default: () => ({
      data: [],
      colors: {},
      legend:{}
    })
  },
  title: { type: String, default: () => "" }
})


const chartBlock = ref(null)


let  chart

/** Helper: разрушить ранее созданный график */
function destroy(ch) {
  if (ch) {
    ch.destroy()
  }
}
function createChartBlock() {
  destroy(chart);
  const labels = props.graphicObj.data.map(d => d.label);

  const LegendKey = Array.from(
      new Set(
          props.graphicObj.data.flatMap(d => Object.keys(d).filter(k => k !== 'label'))
      )
  )
  const colors = [
    'rgba(13,110,253,1)',   // primary
    'rgba(255,193,7,1)',    // warning
    'rgba(220,53,69,1)',    // danger
    'rgba(25,135,84,1)',    // success
    'rgba(32,201,151,1)',   // info-lite
    'rgba(108,117,125,1)'   // secondary
  ]
  chart = new Chart(chartBlock.value, {
    type: 'line',
    data: {
      labels,
      datasets: LegendKey.map((key, idx) => ({
        label: props.graphicObj.legend[key],
        data: props.graphicObj.data.map(d => d[key] ?? 0),
        tension: 0.25,
        borderColor: props.graphicObj.colors[key],
        backgroundColor: props.graphicObj.colors[key].replace('1)', '.15)') ,
        fill: false
      }))
    },
    options: {
      plugins: {
        legend: { position: 'bottom' }
      },
      responsive: true,
      maintainAspectRatio: false
    }
  })
}

onMounted(() => {
  createChartBlock()
})

watch(() => props.statusSeries, createChartBlock, { deep: true })
</script>

<style scoped>
.card {
  overflow: hidden;
}
</style>
